import { ratesLabels } from 'axl-config';

/**
 * Retrieves the obfuscated credit tier based on the provided credit tier.
 * If the credit tier is already obfuscated, it returns the provided credit tier.
 *
 * @param {string} creditTier - The credit tier to be obfuscated.
 * @returns {string} - The obfuscated credit tier or the original credit tier if no match is found.
 */
const getObfuscatedCredit = creditTier => {
  const obfuscatedCredit = Object.keys(ratesLabels).find(key => ratesLabels[key]?.decodedValue === creditTier);
  return obfuscatedCredit || creditTier; // return creditType if it's already obfuscated
};
export { getObfuscatedCredit as default };
